import { ApiResponse } from "src/vzbl-api-handler";

export async function post<
  Route extends (...args: any[]) => any,
  Body extends {} = {}
>(url: string, body?: Body, { signal }: Partial<{ signal: AbortSignal }> = {}) {
  return fetch(url, {
    method: "POST",
    body: JSON.stringify(body || {}),
    signal,
  })
    .then((resp) => resp.json())
    .then((json) => {
      if (json?.error) throw new Error(`${json.error}`);
      if (json?.name === "ZodError")
        throw new Error(JSON.stringify(json.data?.issues, null, 3));
      return json;
    })
    .then((payload: ApiResponse<Route>) => payload);
}

export function orgPoster<
  RequestBody extends {} = {},
  ResponseType extends (...args: any[]) => any = () => any
>(path = "") {
  return (orgId: string, body?: RequestBody) =>
    post<ResponseType>(`/api/${orgId}//${path}`, body);
}
